import { Box, Divider } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledDividerAssign = styled(Divider)(({ theme }) => ({
  width: '30%',
  marginTop: '3rem',
  backgroundColor: theme.palette.primary.dark,
}))

export const StyledBoxAssign = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}))
